/**
 * chain · «собери цепочку по порядку» (S07 BUG-02 happy-path состояний).
 * Контракт:
 *   <div class="chain" data-fin="текст финала">
 *     <div class="chain-instr">…</div>
 *     <div class="chain-pool">
 *       <button type="button" class="ch-chip" data-ord="2" data-own="Dev">IN_PROGRESS</button>
 *       … (авторский порядок в пуле перемешан вручную)
 *     </div>
 *     <div class="chain-line" aria-live="polite"></div>
 *     <div class="chain-fin"></div>
 *   </div>
 * Поведение: клик по чипу — если это следующий по data-ord, чип «улетает» в линию
 * (слот заполняется именем + подписью владельца из data-own), иначе встряска.
 * Собрал всё — финал из data-fin (+ счёт промахов).
 * StrictMode-safe: init-guard сбрасывается в cleanup, DOM восстанавливается.
 */
export function initChain(root: HTMLElement): () => void {
  const cleanups: Array<() => void> = [];
  root.querySelectorAll<HTMLElement>('.chain').forEach((el) => {
    if (el.dataset.chainInit === '1') return;
    el.dataset.chainInit = '1';
    const originalHtml = el.innerHTML;

    const pool = el.querySelector<HTMLElement>('.chain-pool');
    const line = el.querySelector<HTMLElement>('.chain-line');
    const fin = el.querySelector<HTMLElement>('.chain-fin');
    const chips = Array.from(el.querySelectorAll<HTMLButtonElement>('.ch-chip'));
    if (!pool || !line || !fin || chips.length === 0) return;

    const total = chips.length;
    let next = 0;
    let misses = 0;

    // слоты по количеству чипов, со стрелками между
    const slots: HTMLElement[] = [];
    chips.forEach((_, i) => {
      const slot = document.createElement('span');
      slot.className = 'ch-slot';
      slot.textContent = String(i + 1);
      line.appendChild(slot);
      slots.push(slot);
      if (i < total - 1) {
        const arr = document.createElement('span');
        arr.className = 'ch-arr';
        arr.textContent = '→';
        line.appendChild(arr);
      }
    });

    const onClick = (ev: Event) => {
      const chip = (ev.target as HTMLElement).closest<HTMLButtonElement>('.ch-chip');
      if (!chip || chip.classList.contains('done') || next >= total) return;
      const ord = Number(chip.dataset.ord ?? '-1');
      if (ord === next) {
        chip.classList.add('done');
        chip.disabled = true;
        const slot = slots[next]!; // next < total (guarded above) · slots has `total` entries
        slot.classList.add('filled');
        slot.textContent = chip.textContent ?? '';
        const own = chip.dataset.own;
        if (own) {
          const o = document.createElement('span');
          o.className = 'ch-own';
          o.textContent = own;
          slot.appendChild(o);
        }
        next += 1;
        if (next === total) {
          el.classList.add('complete');
          const missNote = misses > 0 ? ` Промахов по пути: ${misses} — перечитай, кто двигает баг на этих шагах.` : ' Ни одного промаха.';
          fin.textContent = (el.dataset.fin ?? 'Цепочка собрана.') + missNote;
          fin.classList.add('show');
        }
      } else {
        misses += 1;
        chip.classList.add('shake');
        window.setTimeout(() => chip.classList.remove('shake'), 420);
      }
    };

    el.addEventListener('click', onClick);
    cleanups.push(() => {
      el.removeEventListener('click', onClick);
      el.innerHTML = originalHtml;
      delete el.dataset.chainInit;
    });
  });
  return () => cleanups.forEach((fn) => fn());
}
